module.exports = __webpack_public_path__ + "img/ico-filter.1aa21866.svg";